<template>
  <div class="adminstor">
    <div class="userManage_header">
      <div class="userManage_logo">
        <img src="@/assets/imgs/icon/feedback_logo.png" alt />
      </div>
      <h3>问题反馈</h3>
    </div>
    <!-- <div class="userManage_form"> -->
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="标题">
        <el-input
          v-model.trim="formInline.title"
          placeholder="请输入标题"
        ></el-input>
      </el-form-item>
      <el-form-item label="反馈用户">
        <el-input
          v-model.trim="formInline.userName"
          placeholder="请输入用户名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="formInline.status" placeholder="请选择">
          <el-option label="待回复" value="2"></el-option>
          <el-option label="已回复" value="0"></el-option>
          <el-option label="已忽略" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="反馈时间">
        <el-date-picker
          v-model="formInline.time"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit" class="bg5584FF formBotton"
          >查询</el-button
        >
        <el-button type="info" @click="reset" class="formBotton"
          >重置</el-button
        >
      </el-form-item>
    </el-form>
    <!-- </div> -->
    <hr class="hr" />
    <!-- 表格数据 -->
    <el-table
      :data="tableData"
      v-loading="loading"
      stripe
      style="width: 100%"
      :header-cell-style="{ backgroundColor: '#DCDFE6', color: '#000' }"
    >
      <el-table-column
        align="center"
        type="index"
        width="100"
        label="序号"
      ></el-table-column>
      <el-table-column prop="title" label="标题" show-overflow-tooltip>
        <template slot-scope="scope">
          <span class="detail" @click="handleDetail(scope.row)">{{
            scope.row.title
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="description"
        label="问题描述"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="userName"
        label="反馈用户"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="department"
        label="单位/企业"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="telephone"
        label="联系方式 "
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="feedBackTime"
        label="反馈时间"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column prop="status" label="状态" align="center">
        <template slot-scope="scope">{{
          scope.row.status == 0
            ? "已回复"
            : scope.row.status == 1
            ? "已忽略"
            : "待回复"
        }}</template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="180">
        <template slot-scope="scope">
          <div v-if="scope.row.status == 0">
            <el-button
              type="primary"
              size="mini"
              class="bg5584FF"
              @click="handleManage(scope.row)"
              >查看回复</el-button
            >
          </div>
          <div v-if="scope.row.status == 1">
            <el-button
              type="primary"
              size="mini"
              class="bg5584FF"
              @click="handleEdit(scope.row)"
              >回复</el-button
            >
          </div>
          <div v-if="scope.row.status == 2">
            <el-button
              type="primary"
              size="mini"
              class="bg5584FF"
              @click="handleEdit(scope.row)"
              >回复</el-button
            >
            <el-button
              type="primary"
              size="mini"
              class="bg5584FF"
              @click="handleDelete(scope.row)"
              >忽略</el-button
            >
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div class="pageBox">
      <!-- <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background
        :current-page.sync="currentPage"
        :page-size="10"
        layout="prev, pager, next, jumper"
        :total="total"
      ></el-pagination> -->
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="10"
        layout="total,  prev, pager, next"
        :total="total"
      >
      </el-pagination>
    </div>
    <!-- 查看问题 -->
    <el-dialog
      title="查看问题"
      :visible.sync="viewProblemsDialogVisible"
      width="770px"
      class="titleChange"
      @close="handleClose"
      :close-on-click-modal="false"
    >
      <div>
        <el-form
          :model="viewReply"
          label-width="135px"
          class="demo-ruleForm inputBorderNone"
          size="small"
        >
          <el-form-item label="标题：" prop="title">
            <el-input v-model="viewReply.title" disabled></el-input>
          </el-form-item>
          <el-form-item label="附件：">
            <ul style="padding: 0; margin: 0">
              <li v-for="item in filesList" :key="item.fileId">
                <!-- <span style="margin-left:14px">{{item.fileName}}</span> -->
                <a
                  :href="`${fileBaseUrl}/system/file/download/${item.fileId}`"
                  >{{ item.fileName }}</a
                >
              </li>
            </ul>
          </el-form-item>
          <el-form-item label="问题描述：" prop="description">
            <el-input
              type="textarea"
              v-model="viewReply.description"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="反馈用户：">
            <el-input v-model="viewReply.userName" disabled></el-input>
          </el-form-item>
          <el-form-item label="联系方式：">
            <el-input
              v-model="viewReply.telephone"
              placeholder="暂无联系方式"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="反馈时间：">
            <el-input v-model="viewReply.feedBackTime" disabled></el-input>
          </el-form-item>
          <el-form-item label="单位/企业：">
            <el-input v-model="viewReply.department" disabled></el-input>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <!-- 回复 -->
    <el-dialog
      title="回复"
      :visible.sync="viewReplyDialogVisible"
      class="titleChange dialog771 bodyScroll"
      @close="replyHandleClose"
      :close-on-click-modal="false"
    >
      <div>
        <el-form
          :model="viewReply"
          label-width="135px"
          class="inputBorderNone"
          size="small"
        >
          <el-form-item label="标题：" prop="title">
            <el-input
              v-model.trim="viewReply.title"
              placeholder="请输入标题"
            ></el-input>
          </el-form-item>
          <el-form-item label="附件：">
            <ul style="padding: 0; margin: 0">
              <li v-for="item in filesList" :key="item.fileId">
                <a
                  :href="`${fileBaseUrl}/system/file/download/${item.fileId}`"
                  >{{ item.fileName }}</a
                >
              </li>
            </ul>
          </el-form-item>
          <el-form-item label="问题描述：" prop="description">
            <el-input
              type="textarea"
              v-model="viewReply.description"
              placeholder="请在200字以内进行描述"
            ></el-input>
          </el-form-item>
          <el-form-item label="反馈用户：">
            <el-input v-model.trim="viewReply.userName" placeholder></el-input>
          </el-form-item>
          <el-form-item label="联系方式：">
            <el-input
              v-model.trim="viewReply.telephone"
              placeholder="请输入联系方式"
            ></el-input>
          </el-form-item>
          <el-form-item label="反馈时间：">
            <el-input v-model="viewReply.feedBackTime" placeholder></el-input>
          </el-form-item>
          <el-form-item label="单位/企业：">
            <el-input
              v-model.trim="viewReply.department"
              placeholder="请输入单位/企业"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="viewReply">
          <el-form
            :model="editRuleForm"
            :rules="rules"
            ref="editRuleForm"
            label-width="100px"
            class="demo-ruleForm formWidth"
            size="small"
            v-loading="replyloading"
          >
            <div class="left0">
              <el-form-item label="回复附件：" prop="title">
                <el-upload
                  class="upload-demo"
                  :action="`${fileBaseUrl}/system/file/upload`"
                  :on-success="handleSuccess"
                  :on-error="handleError"
                  :on-preview="handlePreview"
                  :on-remove="handleRemove"
                  :before-remove="beforeRemove"
                  :limit="3"
                  :on-exceed="handleExceed"
                  :file-list="fileList"
                  multiple
                >
                  <el-button size="small" type="primary">
                    <i class="el-icon-upload"></i>上传附件
                  </el-button>
                </el-upload>
              </el-form-item>
              <el-form-item label="回复人：">
                <el-input v-model="editRuleForm.replyUser" disabled></el-input>
              </el-form-item>
              <el-form-item label="回复时间：">
                <el-input v-model="editRuleForm.replyTime" disabled></el-input>
              </el-form-item>
            </div>
            <div class="right">
              <el-form-item label="回复内容：" prop="replyContent">
                <el-input
                  type="textarea"
                  v-model="editRuleForm.replyContent"
                  placeholder="请在200字以内进行描述"
                ></el-input>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div class="btnBox">
          <el-button type="primary" @click="submitForm('editRuleForm')"
            >提交</el-button
          >
          <el-button @click="viewReplyDialogVisible = false">取消</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 查看回复 -->
    <el-dialog
      title="查看回复"
      :visible.sync="replyDialogVisible"
      width="770px"
      class="titleChange"
      @close="handleClose"
      :close-on-click-modal="false"
    >
      <div>
        <el-form
          :model="viewReply"
          label-width="135px"
          class="demo-ruleForm inputBorderNone"
          size="small"
        >
          <el-form-item label="标题：" prop="title">
            <el-input v-model="viewReply.title" disabled></el-input>
          </el-form-item>
          <el-form-item label="附件：">
            <ul style="padding: 0; margin: 0">
              <li v-for="item in filesList" :key="item.fileId">
                <a
                  :href="`${fileBaseUrl}/system/file/download/${item.fileId}`"
                  >{{ item.fileName }}</a
                >
              </li>
            </ul>
          </el-form-item>
          <el-form-item label="问题描述：" prop="description">
            <el-input
              type="textarea"
              v-model="viewReply.description"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="反馈用户：">
            <el-input v-model="viewReply.userName" disabled></el-input>
          </el-form-item>
          <el-form-item label="联系方式：">
            <el-input
              v-model="viewReply.telephone"
              placeholder="暂无联系方式"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="反馈时间：">
            <el-input v-model="viewReply.feedBackTime" disabled></el-input>
          </el-form-item>
          <el-form-item label="单位/企业：">
            <el-input v-model="viewReply.department" disabled></el-input>
          </el-form-item>
        </el-form>
        <div class="viewReply">
          <ul>
            <li>
              <p>
                <span>回复人：</span>
                <span>{{ viewReplyList.replyUser }}</span>
              </p>
              <p>
                <span>回复时间：</span>
                <span>{{ viewReplyList.replyTime }}</span>
              </p>
            </li>
            <li>
              <p>
                <span>回复内容：</span>
                <el-input
                  disabled
                  class="inputBorderNone"
                  type="textarea"
                  v-model="viewReplyList.replyContent"
                ></el-input>
              </p>
            </li>
            <li>
              <p>
                <span>回复附件：</span>
                <a
                  :href="`${fileBaseUrl}/system/file/download/${item.fileId}`"
                  v-for="item in viewFilesList"
                  :key="item.feedBackId"
                  style="margin-right: 8px"
                  >{{ item.fileName }}</a
                >
              </p>
            </li>
          </ul>
        </div>
      </div>
    </el-dialog>
    <!-- 删除弹框 -->
    <el-dialog
      title="忽略"
      :visible.sync="deleteDialogVisible"
      class="delete"
      :close-on-click-modal="false"
    >
      <p>确认要忽略吗？</p>
      <div class="btnBox MT40">
        <el-button
          type="primary"
          size="mini"
          class="bg5584FF"
          @click="sureDelete"
          >确定</el-button
        >
        <el-button
          type="normal"
          size="mini"
          @click="deleteDialogVisible = false"
          >取消</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { Message } from "element-ui";
export default {
  name: "Adminstor",
  data() {
    var checkLength = (rule, value, callback) => {
      if (!value) {
        // callback();
        return callback(new Error("回复类容不能为空")); //必填验证
      }
      if (value.length > 200) {
        callback(
          new Error("输入长度限制为200字符，当前输入长度" + value.length)
        );
      } else {
        callback();
      }
    };
    return {
      viewProblemsDialogVisible: false,
      viewReplyDialogVisible: false,
      replyDialogVisible: false,
      deleteDialogVisible: false,
      currentPage: 1,
      pageNum: 1,
      total: 0,
      feedBackId: "",
      fileList: [],
      filesList: [],
      viewReplyList: [],
      viewFilesList: [], //回复文件列表
      loading: false,
      replyloading: false,
      feedBackDescription: "",
      fileBaseUrl: this.$GLOBAl.fileBaseUrl,
      formInline: {
        //查询对象
        title: "",
        userName: "",
        status: "",
        time: "",
      },
      viewReply: {
        //提交表单
        title: "",
        files: "",
        description: "",
        userName: "",
        telephone: "",
        feedBackTime: "",
        department: "",
      },
      editRuleForm: {
        replyUser: "",
        replyTime: "",
        replyFiles: [],
        replyContent: "",
        feedBackId: "",
      },
      rules: {
        //表单验证规则
        replyContent: [
          { required: true, validator: checkLength, trigger: "change" },
        ],
      },
      tableData: [],
    };
  },
  created() {
    this.getData(this.pageNum);
  },
  methods: {
    getData(pageNum) {
      this.loading = true;
      this.$axios
        .get("/system/feedback/searchFeedBackPageList", {
          params: {
            pageNum: pageNum,
            pageSize: 10,
            title: this.formInline.title,
            userName: this.formInline.userName,
            status: this.formInline.status,
            date1: this.formInline.time == "" ? "" : this.formInline.time[0],
            date2: this.formInline.time == "" ? "" : this.formInline.time[1],
          },
        })
        .then((res) => {
          this.tableData = res.data;
          this.total = res.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    onSubmit() {
      // console.log(this.formInline);
      this.getData(this.pageNum);
    },
    reset() {
      // console.log("重置");
      for (const key in this.formInline) {
        this.formInline[key] = "";
      }
      this.pageNum = 1;
      this.getData(this.pageNum);
      this.currentPage = 1;
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      //跳转页
      // console.log(`当前页: ${val}`);
      this.pageNum = val;
      this.getData(val);
    },
    handleDetail(row) {
      this.viewProblemsDialogVisible = true;
      this.$axios
        .get(`/system/feedback/selectFeedBackDetail/${row.id}`)
        .then((res) => {
          JSON.parse(res.data.files).forEach((item) => {
            this.filesList.push(JSON.parse(item));
          });
          this.viewReply = res.data;
        });
    },
    handleManage(row) {
      //查看回复
      this.replyDialogVisible = true;
      this.$axios
        .get(`/system/feedback/selectFeedBackDetail/${row.id}`)
        .then((res) => {
          JSON.parse(res.data.files).forEach((item) => {
            this.filesList.push(JSON.parse(item));
          });
          this.viewReply = res.data;
        });
      this.$axios
        .get(`/system/reply/selectByPrimaryKey/${row.replyId}`)
        .then((res) => {
          this.viewReplyList = res.data;
          this.viewFilesList = JSON.parse(res.data.replyFiles);
          // console.log(this.viewFilesList);
        });
    },
    handleEdit(row) {
      //回复
      // console.log(row);
      this.viewReplyDialogVisible = true;
      this.editRuleForm.replyUser = sessionStorage.getItem("name");
      this.editRuleForm.replyTime = this.$moment(new Date()).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      this.editRuleForm.feedBackId = row.id;
      this.$axios
        .get(`/system/feedback/selectFeedBackDetail/${row.id}`)
        .then((res) => {
          JSON.parse(res.data.files).forEach((item) => {
            this.filesList.push(JSON.parse(item));
          });
          this.viewReply = res.data;
          // console.log(this.filesList);
        });
    },
    handleClose() {
      this.filesList = [];
    },
    replyHandleClose() {
      this.fileList = [];
      this.filesList = [];
      this.editRuleForm.replyFiles = [];
      this.$refs.editRuleForm.resetFields();
    },
    handleDelete(row) {
      //忽略
      // console.log(row);
      this.deleteDialogVisible = true;
      this.feedBackId = row.id;
    },
    submitForm(formName) {
      //回复提交
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.replyloading = true;
          this.editRuleForm.replyFiles = JSON.stringify(
            this.editRuleForm.replyFiles
          );
          this.$axios
            .post("/system/reply/insertReplyInfo", this.editRuleForm)
            .then(() => {
              Message.success("已回复");
              this.replyloading = false;
              this.viewReplyDialogVisible = false;
              for (let key in this.editRuleForm) {
                if (key == "replyUser") {
                  break;
                } else if (key == "replyFiles") {
                  this.editRuleForm[key] = [];
                } else {
                  this.editRuleForm[key] = "";
                }
              }
              this.getData(this.pageNum);
            })
            .catch(() => {
              this.replyloading = false;
            });
        } else {
          // Message.error("请完善表单信息");
          return false;
        }
      });
    },
    handleSuccess(response, file, fileList) {
      Message.success("上传成功");
      // console.log(response, file, fileList);
      this.editRuleForm.replyFiles.push(response.data);
    },
    handleError(err, file, fileList) {
      // console.log(err, file, fileList);
      Message.error("上传失败");
    },
    handleRemove(file, fileList) {
      // console.log(file, fileList);
      this.editRuleForm.replyFiles = this.editRuleForm.replyFiles.filter(
        (item) => {
          return item != file.response.data;
        }
      );
    },
    handlePreview(file) {
      // console.log(file);
    },
    handleExceed(files, fileList) {
      // console.log(files);
      // console.log(fileList);
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    beforeRemove(file) {
      return this.$confirm(`确定移除 ${file.name}？`).then(() => {
        // console.log(file)
        // this.$axios.get(`/file/delete/${file.response.data}`);
      });
    },
    sureDelete() {
      this.$axios
        .get(
          `/system/feedback/updateStatusByPrimaryKey/${this.feedBackId}/1`,
          {}
        )
        .then(() => {
          this.deleteDialogVisible = false;
          this.getData(this.pageNum);
          Message.success("已忽略");
        });
    },
  },
};
</script>
<style lang="less" scoped>
.userManage_header {
  height: 31px;
  width: 100%;
  display: flex;
  margin-bottom: 29px;
  .userManage_logo {
    margin: 2px 20px 0 2px;
  }
  h3 {
    font-size: 24px;
    height: 100%;
    margin: 0;
    color: #444444;
  }
}
.userManage_form {
  height: 70px;
  width: 100%;
  box-sizing: border-box;
  border-bottom: 1px solid rgba(155, 155, 155, 0.25);
  margin-bottom: 20px;
  .el-form {
    .el-form-item {
      margin-right: 30px;
    }
  }
}
.detail {
  width: 100%;
  height: 100%;
  cursor: pointer;
  color: #5584ff;
}
.viewReply {
  width: 100%;
  min-height: 200px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 9px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(0, 0, 0, 0.06);
  box-sizing: border-box;
  padding: 5% 3%;
  .el-form {
    display: flex;
  }
  .left0 {
    width: 50%;
    // display: inline-block;
  }
  .right {
    width: 50%;
    // display: inline-block;
  }
  ul {
    padding: 0 !important;
    margin: 0 !important;
    width: 100%;
    height: 100%;
    li {
      width: 100%;
      height: 33.33%;
      p {
        display: inline-block;
        width: 100%;
        span {
          display: inline-block;
        }
      }
    }
    li:nth-child(1) {
      p {
        width: 50%;
      }
    }
    li:nth-child(2) {
      p {
        display: flex;
        span {
          width: 84px;
        }
      }
    }
  }
}
</style>